import { render, staticRenderFns } from "./AccidentStatusView.vue?vue&type=template&id=25fec908"
import script from "./AccidentStatusView.vue?vue&type=script&lang=js"
export * from "./AccidentStatusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports